<template>
  <div>
    <a-row :gutter="10">
      <a-col :md="leftColMd" :sm="24" style="margin-bottom: 20px">
        <a-card :bordered="false">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24"> </a-row>
            </a-form>
          </div>
          <!-- 查询区域-END -->

          <!-- 操作按钮区域 -->
          <div class="table-operator">
            <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
          </div>

          <!-- table区域-begin -->
          <div>
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: true }"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
              class="j-table-force-nowrap"
              @change="handleTableChange"
            >
              <template slot="htmlSlot" slot-scope="text">
                <div v-html="text"></div>
              </template>
              <template slot="imgSlot" slot-scope="text">
                <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
                <img
                  v-else
                  :src="getImgView(text)"
                  height="25px"
                  alt=""
                  style="max-width: 80px; font-size: 12px; font-style: italic"
                />
              </template>
              <template slot="fileSlot" slot-scope="text">
                <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
                <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
                  下载
                </a-button>
              </template>

              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">编辑</a>

                <a-divider type="vertical" />
                <a-dropdown>
                  <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="handleTenantRole(record)">角色</a>
                    </a-menu-item>
                    <a-menu-item>
                      <a @click="handleDetail(record)">详情</a>
                    </a-menu-item>
                    <a-menu-item>
                      <a @click="handleAppPerssion(record.id)">应用授权</a>
                    </a-menu-item>
                    <a-menu-item>
                      <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                        <a>删除</a>
                      </a-popconfirm>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </span>
            </a-table>
          </div>
        </a-card>
      </a-col>
      <a-col :md="rightColMd" :sm="24" v-if="this.rightcolval == 1">
        <a-card :bordered="false">
          <tenant-role-user-list ref="modalTenantRoleUserList" />
        </a-card>
      </a-col>
    </a-row>
    <tenant-modal ref="modalForm" @ok="modalFormOk"></tenant-modal>
    <tenant-app-modal ref="modalAppTenant"></tenant-app-modal>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TenantModal from './modules/TenantModal'
import TenantAppModal from './modules/TenantAppModal.vue'
import TenantRoleUserList from './TenantRoleUserList.vue'

export default {
  name: 'TenantList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    TenantModal,
    TenantAppModal,
    TenantRoleUserList,
  },
  data() {
    return {
      description: 'adad管理页面',
      // 表头
      columns: [
        {
          title: '租户名称',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '租户编号',
          align: 'center',
          dataIndex: 'id',
        },
        {
          title: '开始时间',
          align: 'center',
          dataIndex: 'beginDate',
        },
        {
          title: '结束时间',
          align: 'center',
          dataIndex: 'endDate',
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status_dictText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/sys/tenant/list',
        delete: '/sys/tenant/delete',
        deleteBatch: '/sys/tenant/deleteBatch',
      },
      dictOptions: {},
      rightcolval: false,
    }
  },
  created() {},
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    leftColMd() {
      return this.selectedRowKeys.length === 0 ? 24 : 8
    },
    rightColMd() {
      return this.selectedRowKeys.length === 0 ? 0 : 16
    },
  },
  methods: {
    initDictConfig() {},
    handleAppPerssion(tenantId) {
      this.$refs.modalAppTenant.show(tenantId,'e')
    },
    handleTenantRole(record) {
      this.rightcolval = true
      this.selectedRowKeys = [record.id]
      this.selectionRows = [record]
      this.$nextTick(() => {
        this.$refs.modalTenantRoleUserList.switchTenant(record.id)
      })
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.handleTenantRole(selectionRows[0])
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>